import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';
import { TranslatePipe } from '../pipes/translate.pipe';
import { RtlService } from '../services/rtl.service';
import { BrandService } from '../../services/brand-config.service';

/**
 * iOS-only onboarding dialog that explains how to add the home-screen widget.
 * iOS has no API to pin a widget programmatically (unlike Android's
 * requestPinAppWidget), so we guide the user through the manual steps.
 */
@Component({
  selector: 'app-widget-instructions',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    A11yModule,
    TranslatePipe,
  ],
  templateUrl: './widget-instructions.component.html',
  styleUrl: './widget-instructions.component.scss',
})
export class WidgetInstructionsComponent {
  readonly brand = this.brandService.config.brandName;
  readonly steps = [1, 2, 3, 4, 5];

  constructor(
    private dialogRef: MatDialogRef<WidgetInstructionsComponent>,
    public rtlService: RtlService,
    private brandService: BrandService
  ) {}

  close(): void {
    this.dialogRef.close(true);
  }
}
